import CancelButton from '../CancelButton';
import StepWaitingTime from '../StepWaitingTime';
import { useWatch } from 'react-hook-form';
import { useState } from 'react';
import { ActionButtons, BigPriceSquare, InfoButton, Para, Stack } from 'ui-components';
import { ControlledCheckBox, BookingPayment } from 'controlled-components';
import StepContainer from '../../StepContainer';
import { CouponInsert } from '../../../CouponInsert';
import { computeBookingPrice } from '../../../computeBookingPrice';
import { BasicCouponFragment, CompleteStoreFragment } from 'drycut-graphql';
import { useBookingContext } from '../../BookingProvider';

type Props = {
  store: CompleteStoreFragment;
  onCancel: () => void;
};

export function PaymentStep({ store, onCancel }: Props): JSX.Element {
  const [selectedCoupon, setSelectedCoupon] = useState<BasicCouponFragment>();
  const { manual } = useBookingContext();

  const customerName = useWatch({ name: 'name' });
  const phoneNumber = useWatch({ name: 'phone' });
  const silentBooking = useWatch({ name: 'silentBooking' });
  const kidCustomer = useWatch({ name: 'kidCustomer' });

  const computedPrice = computeBookingPrice({
    service: store.service,
    coupon: selectedCoupon,
    kidCustomer,
  });

  return (
    <StepContainer store={store}>
      <StepWaitingTime store={store} />

      <Stack gap={2} className="items-center">
        <Para>Jetzt Buchen:</Para>
        <BigPriceSquare price={computedPrice} />

        {Boolean(store.service?.kidsPrice) && (
          <ControlledCheckBox name="kidCustomer" label="Ich bin ein Kind (unter 12 Jahre alt)" />
        )}

        <Stack gap={2} direction="row">
          <ControlledCheckBox name="silentBooking" label="Silent Cut" />
          <InfoButton
            title="Silent cut"
            text="Nach der Beratung und Besprechung des Schnitts geniesse ich meinen Schnitt heute gerne in Ruhe und verzichte auf Smalltalk."
          />
        </Stack>
      </Stack>

      <CouponInsert onValidate={setSelectedCoupon} />

      <Para size="sm" className="w-72 text-center text-zinc-700">
        Wir bitten Dich, 5 Minuten vor Deinem Termin im Salon zu erscheinen.
      </Para>

      <ActionButtons>
        <BookingPayment
          amount={computedPrice}
          data={{
            manual,
            customerName,
            phoneNumber,
            silentBooking,
            kidCustomer,
            couponCode: selectedCoupon?.code,
            storeSlug: store.slug,
          }}
        />
        <CancelButton onCancel={onCancel} />
      </ActionButtons>
    </StepContainer>
  );
}
